require('./_set-species')('Array');


//////////////////
// WEBPACK FOOTER
// /var/www/umem/~/core-js/modules/es6.array.species.js
// module id = 194
// module chunks = 0